import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { EmailLogSearch } from '../EmailLogSearch/EmailLogSearch';

export const EmailLogManagerPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle" className="d-inline">
        Email Log Viewer
      </h1>
      <EmailLogSearch />
    </Layout>
  );
};
